module.exports = "https://cdn.redage.net/src/views/player/oressale/assets/images/wood_maple.png";